import React from 'react';
import BaseSelectField from '../BaseSelectField';
import {
  lifeCycleEntitiesMap,
  selectFieldNames,
} from '../../constants/lifeCycle';
import { useRoomSteps } from '../../../../../queries/useRoomSteps';

const settings = {
  name: selectFieldNames[lifeCycleEntitiesMap.step],
  label: 'Этап',
};

const SelectStep = ({ roomId, control, initialValue, setIsFetchError }) => {
  const { data, isFetching, refetch } = useRoomSteps({ addressId: roomId });

  return (
    <BaseSelectField
      data={data}
      isFetching={isFetching}
      refetch={refetch}
      fetchErrMsg="Не удалось загрузить список доступных этапов"
      control={control}
      fieldSettings={settings}
      initialValue={initialValue}
      setIsFetchError={setIsFetchError}
    />
  );
};

export default SelectStep;
